import { ISlideData } from '../../modules/carousel/interfaces';

export const copyHints = (hints: ISlideData[]): ISlideData[] =>
  hints.map((h: ISlideData) => structuredClone(h));
